import { defineRouting } from "next-intl/routing";

import { createNavigation } from "next-intl/navigation";

export const koLocale: string = "ko";
export const enLocale: string = "en";
export const defaultLocale: string = koLocale;
export const fallbackLocale: string = defaultLocale;
export const locales = [koLocale, enLocale];
export const localePrefix = "as-needed";

export const routing = defineRouting({
  localePrefix,
  locales: locales,
  defaultLocale: defaultLocale,
});
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
